import React, {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useRef,
} from 'react';
import { Button } from '../../../../components/Button/Button';
import { Modal, ModalRef } from '../../../../components/Modal/Modal';
import { useLanguage } from '../../../../locale/useLanguage';

import './RemoveItemModal.css';

type RemoveItemModalProps = {
  onRemoveItem: () => void;
  productType: string;
  productDescription: string;
};

export const RemoveItemModal: React.ForwardRefExoticComponent<
  RemoveItemModalProps & React.RefAttributes<ModalRef>
> = forwardRef(
  ({ onRemoveItem, productType, productDescription }, forwardedRef) => {
    const [t] = useLanguage();
    const modalRef = useRef<ModalRef>(null);

    useImperativeHandle(forwardedRef, () => ({
      openModal: modalRef.current!.openModal,
      closeModal: modalRef.current!.closeModal,
    }));

    const removeItem = useCallback(() => {
      modalRef.current?.closeModal();
      onRemoveItem();
    }, [onRemoveItem]);

    const close = useCallback(() => {
      modalRef.current?.closeModal();
    }, []);

    return (
      <Modal ref={modalRef}>
        <h3 className="modal-title">{t('cart.removeModalTitle')}</h3>
        <p className="modal-description">{t('cart.removeModalDescription')}</p>
        <p className="remove-item-modal--product-type">{productType}</p>
        <p className="remove-item-modal--product-description">
          {productDescription}
        </p>
        <div className="modal-button-container">
          <Button
            onClick={removeItem}
            label={t('cart.removeModalConfirm')}
            isPrimary
          />
          <div className="remove-item-modal--exit-button">
            <Button onClick={close} label={t('cart.removeModalBack')} />
          </div>
        </div>
      </Modal>
    );
  }
);
